module.exports = __webpack_public_path__ + "files/ccdf7ee55897bd14b49962d763637a83.png";